import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";
import { Loader2 } from "lucide-react";

export const PvpButton = ({ employee, behavior, saved, pvp }) => {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const open = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (pvp) return navigate(`/pvp/${pvp.id}`);
    if (!saved) return toast.error("Sla de medewerker eerst op met deze vaardigheid");
    setBusy(true);
    toast.info("De AI stelt een concept-PVP op op basis van wat al bekend is…", { duration: 8000 });
    try {
      const { data } = await api.post("/pvps", { employee_id: employee.id, behavior_id: behavior.id });
      navigate(`/pvp/${data.id}`);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "PVP starten mislukt");
      setBusy(false);
    }
  };
  if (!saved && !pvp) return null;
  return (
    <button
      onClick={open}
      disabled={busy}
      className={`shrink-0 font-mono text-[10px] font-bold px-2 py-0.5 border transition-colors ${pvp ? "bg-zinc-900 text-white border-zinc-900 hover:bg-zinc-700" : "border-zinc-900 hover:bg-zinc-900 hover:text-white"}`}
      title={pvp ? (pvp.via_team ? `Team-PVP (gestart bij ${pvp.employee_name})` : pvp.scope === "team" ? "Team-PVP verder invullen" : "PVP verder invullen") : "PVP starten"}
      data-testid={`pvp-button-${behavior.id}`}
    >
      {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : pvp?.scope === "team" ? "TEAM-PVP" : "PVP"}
    </button>
  );
};
